module.exports = __webpack_public_path__ + "static/media/pg07.bf0a0fe3.jpg";